angular.module('qkr').factory('paymentgatewayService', ($http, appConfig, gettextCatalog, utils, merchantService) => ({
        paymentSystems: null,

        getPaymentSystems() {
            const self = this;

            if (utils.hasNoValue(self.paymentSystems)) {
                return $http.get(appConfig.apiUrl + 'paymentConfig/getTypes').then((response) => {
                    self.paymentSystems = response.data;
                    return self.paymentSystems;
                });
            } else {
                return self.paymentSystems;
            }
		},

        mapPaymentSystem(beanName, availablePaymentSystems) {
            if (!beanName)
                return 0;

            const provider = beanName.toLowerCase().replace(/paymentconfig$/, '');

            for (let i = availablePaymentSystems.length - 1; i >= 0; i--) {
                if (availablePaymentSystems[i].name.toLowerCase() === provider)
                    return i;
            }

            return 0;
        },

        getBankAccountTypes() {
            const bankAccountTypes = [];
            const merchantAccountType = {key: 'MERCHANT_ACCOUNT', name: gettextCatalog.getString('Merchant Account')};
            const thirdPartyType = {key: '3rd_PARTY', name: gettextCatalog.getString('3rd Party')};

            bankAccountTypes.push(merchantAccountType);
            bankAccountTypes.push(thirdPartyType);

            return bankAccountTypes;
        },

        getDefaultBankAccountTypeKey() {
            if (merchantService.behaviour(merchantService.merchantInfo, 'paymentSetting.isAustralia')) {
                return merchantService.behaviour(merchantService.merchantInfo, 'paymentSetting.isSupplier') ?
                    '3rd_PARTY' : 'MERCHANT_ACCOUNT';
            } else {
                return '';
            }
        },

		loadPaymentSettingsId(paymentId) {
			var paymentId = 0;
            return $http.get(appConfig.apiUrl + 'paymentConfig/get/' + paymentId, {withCredentials: true})
                .then((response) => response.data);
        },
        
        loadPaymentSettingsList() {
             return $http.get(appConfig.apiUrl + 'paymentConfig/list', {withCredentials: true});
         },

        createPaymentSettingsMigs(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    purchaseMode: form.purchaseMode,
                    vpcMerchant: form.migsVPCMerchant,
                    currency: form.currency,
                    accessCode: form.migsAccessCode,
                    key: form.migsKey,
                    refundUserId: form.migsRefundUserId,
                    refundPasswordKey: form.migsRefundPwdKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    cbaMerchantNumber: form.cbaMerchantNumber,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/createMigs', payload);
        },

        updatePaymentSettingsMigs(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    purchaseMode: form.purchaseMode,
                    vpcMerchant: form.migsVPCMerchant,
                    currency: form.currency,
                    accessCode: form.migsAccessCode,
                    key: form.migsKey,
                    refundUserId: form.migsRefundUserId,
                    updatedPassword: form.migsRefundPwdKey,
                    bankAccountType: form.bankAccountType,
                    cbaMerchantNumber: form.cbaMerchantNumber,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateMigs', payload);
        },

        createPaymentSettingsMpgs(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    username: form.mpgsUsername,
                    password: form.mpgsPassword,
                    payMode: form.mpgsPayMode,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    cbaMerchantNumber: form.cbaMerchantNumber,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/createMPGS', payload);
        },

        updatePaymentSettingsMpgs(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    username: form.mpgsUsername,
                    updatedPassword: form.mpgsPassword,
                    payMode: form.mpgsPayMode,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    cbaMerchantNumber: form.cbaMerchantNumber,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateMPGS', payload);
        },

        createPaymentSettingsBraspag(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    username: form.brasUsername,
                    password: form.brasPassword,
                    providerId: form.brasProviderId,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/createBraspag', payload);
        },

        updatePaymentSettingsBraspag(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    username: form.brasUsername,
                    providerId: form.brasProviderId,
                    updatedPassword: form.brasPassword,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateBraspag', payload);
        },

        createPaymentSettingsDatacash(form, assignmentChanges) {
           const payload = {
               paymentConfig: {
                   alias: form.alias,
                   datacashId: form.datacashId,
                   datacashPasswordKey: form.datacashPassword,
                   bankAccountType: form.bankAccountType,
                   bankName: form.bankName,
                   bankCutoffInMinutes: form.bankCutoffInMinutes,
                   bankCutoffTimeZone: form.bankCutoffTimeZone
               },
               departments: assignmentChanges
           };
           return $http.post(appConfig.apiUrl + 'paymentConfig/createDatacash', payload);
        },
 
        updatePaymentSettingsDatacash(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    datacashId: form.datacashId,
                    updatedDatacashPassword: form.datacashPassword,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateDatacash', payload);
         },

         // Api doesn't exist yet
        createPaymentSettingsSimplify(form, assignmentChanges) {
           const payload = {
               paymentConfig: {
                   alias: form.alias,
                   publicKey: form.simplifyPublicKey,
                   privateKey: form.simplifyPrivateKey,
                   bankAccountType: form.bankAccountType,
                   bankName: form.bankName,
                   bankCutoffInMinutes: form.bankCutoffInMinutes,
                   bankCutoffTimeZone: form.bankCutoffTimeZone
               },
               departments: assignmentChanges
           };

           return $http.post(appConfig.apiUrl + 'paymentConfig/createSimplifyCommerce', payload);
        },

        // Api doesn't exist yet
        updatePaymentSettingsSimplify(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    updatedPublicKey: form.simplifyPublicKey,
                    updatedPrivateKey: form.simplifyPrivateKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateSimplifyCommerce', payload);
         },

        createPaymentSettingsMoneris(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    storeId: form.monerisStoreId,
                    token: form.monerisToken,
                    customerId: form.monerisCustomerId,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createMoneris', payload);
        },

        updatePaymentSettingsMoneris(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    storeId: form.monerisStoreId,
                    token: form.monerisToken,
                    customerId: form.monerisCustomerId,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateMoneris', payload);
        },

        createPaymentSettingsSetefi(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    terminalId: form.setefiTerminalId,
                    terminalPassword: form.setefiTerminalPassword,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createSetefi', payload);
        },

        updatePaymentSettingsSetefi(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    terminalId: form.setefiTerminalId,
                    terminalPassword: form.setefiTerminalPassword,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateSetefi', payload);
        },
        createPaymentSettingsPaymentez(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    applicationKey: form.paymentezAppKey,
                    applicationCode: form.paymentezAppCode,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createPaymentez', payload);
        },
        updatePaymentSettingsPaymentez(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    applicationCode: form.paymentezAppCode,
                    updatedApplicationKey: form.paymentezAppKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updatePaymentez', payload);
        },

        createPaymentSettingsQuest(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    terminalId: form.questTerminalId,
                    instructionStockId: form.questInstructionStockId,
                    customerNameStockId: form.questCustomerNameStockId,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createQuest', payload);
        },
        updatePaymentSettingsQuest(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    terminalId: form.questTerminalId,
                    instructionStockId: form.questInstructionStockId,
                    customerNameStockId: form.questCustomerNameStockId,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateQuest', payload);
        },

        createPaymentSettingsTD(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    applicationKey: form.tdAppKey,
                    apiKeyReports: form.tdApiKeyReports,
                    mid: form.tdMerchantId,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createTD', payload);
        },
        updatePaymentSettingsTD(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    mid: form.tdMerchantId,
                    updatedApplicationKey: form.tdAppKey,
                    updatedApiKeyReports: form.tdApiKeyReports,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateTD', payload);
        },
        createPaymentSettingsTransbank(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    commerceId: form.transbankCommerceId,
                    commerceCode: form.transbankCommerceCode,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createTransbank', payload);
        },

        updatePaymentSettingsTransbank(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    commerceId: form.transbankCommerceId,
                    commerceCode: form.transbankCommerceCode,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateTransbank', payload);
        },
        createPaymentSettingsMasterPassApp(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    username: form.username,
                    password: form.password,
                    libLiteApiToken: form.libLiteApiToken,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createMasterPassApp', payload);
        },

        updatePaymentSettingsMasterPassApp(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    username: form.username,
                    updatedPassword: form.password,
                    libLiteApiToken: form.libLiteApiToken,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateMasterPassApp', payload);
        },

        createPaymentSettingsWorldPay(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    username: form.worldPayUsername,
                    password: form.worldPayPassword,
                    merchantCode: form.worldPayMerchantCode,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createWorldPay', payload);
        },

        updatePaymentSettingsWorldPay(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    username: form.worldPayUsername,
                    updatedPassword: form.worldPayPassword,
                    merchantCode: form.worldPayMerchantCode,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateWorldPay', payload);
        },

        createPaymentSettingsFirstData(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    firstDataMerchantId: form.firstDataMerchantId,
                    firstDataTerminalId: form.firstDataTerminalId,
                    firstDataGroupId: form.firstDataGroupId,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/createFirstData', payload);
        },

        updatePaymentSettingsFirstData(id, form, assignmentChanges) {
            const payload = {
                    paymentConfig: {
                        id,
                        alias: form.alias,
                        firstDataMerchantId: form.firstDataMerchantId,
                        firstDataTerminalId: form.firstDataTerminalId,
                        bankAccountType: form.bankAccountType,
                        bankName: form.bankName,
                        bankCutoffInMinutes: form.bankCutoffInMinutes,
                        bankCutoffTimeZone: form.bankCutoffTimeZone
                    },
                    departments: assignmentChanges
                }
                ;
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateFirstData', payload);
        },

        createPaymentSettingsMCPayment(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    mcPaymentMerchantId: form.mcPaymentMerchantId,
                    secretKey: form.mcPaymentSecretKey,
                    currency: form.mcPaymentCurrency,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/createMCPayment', payload);
        },

        updatePaymentSettingsMCPayment(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    mcPaymentMerchantId: form.mcPaymentMerchantId,
                    updatedSecretKey: form.mcPaymentSecretKey,
                    currency: form.mcPaymentCurrency,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateMCPayment', payload);
        },

        createPaymentSettingsMIT(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    username: form.mitPaymentUsername,
                    password: form.mitPaymentPassword,
                    merchantCode: form.mitPaymentMerchantCode,
                    companyId: form.mitPaymentCompany,
                    branchId: form.mitPaymentBranch,
                    operationType: form.mitPaymentOperationType,
                    merchantKey: form.mitPaymentMerchantKey,
                    secretKey: form.mitPaymentSecretKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createMITPayment', payload);
        },

        updatePaymentSettingsMIT(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    username: form.mitPaymentUsername,
                    updatedPassword: form.mitPaymentPassword,
                    merchantCode: form.mitPaymentMerchantCode,
                    companyId: form.mitPaymentCompany,
                    branchId: form.mitPaymentBranch,
                    operationType: form.mitPaymentOperationType,
                    merchantKey: form.mitPaymentMerchantKey,
                    secretKey: form.mitPaymentSecretKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateMITPayment', payload);
        },

        createPaymentSettingsStripe(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    merchantKey: form.stripePaymentMerchantKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createStripePayment', payload);
        },

        updatePaymentSettingsStripe(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    updatedMerchantKey: form.stripePaymentMerchantKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateStripePayment', payload);
        },

        createPaymentSettingsStripe(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    merchantKey: form.stripePaymentMerchantKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/createStripePayment', payload);
        },

        updatePaymentSettingsStripe(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    merchantKey: form.stripePaymentMerchantKey,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };

            return $http.post(appConfig.apiUrl + 'paymentConfig/updateStripePayment', payload);
        },

        createPaymentSettingsWirecard: function(form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    alias: form.alias,
                    username: form.wirecardUsername,
                    password: form.wirecardPassword,
                    merchantCode: form.wirecardMerchantCode,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/createWirecard', payload);
        },
        updatePaymentSettingsWirecard: function(id, form, assignmentChanges) {
            const payload = {
                    paymentConfig: {
                        id: id,
                        alias: form.alias,
                        username: form.wirecardUsername,
                        updatedPassword: form.wirecardPassword,
                        updatedMerchantCode: form.wirecardMerchantCode,
                        bankAccountType: form.bankAccountType,
                        bankName: form.bankName,
                        bankCutoffInMinutes: form.bankCutoffInMinutes,
                        bankCutoffTimeZone: form.bankCutoffTimeZone
                    },
                    departments: assignmentChanges
                }
            ;
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateWirecard', payload);
        },

        createPaymentSettingsCheckout(payload) {
            return $http.post(appConfig.apiUrl + 'paymentConfig/createCheckoutPayment', payload);
        },

        updatePaymentSettingsCheckout(payload) {
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateCheckoutPayment', payload);
        },

        createPaymentSettingsRedsys(payload) {
            return $http.post(appConfig.apiUrl + 'paymentConfig/createRedsysPayment', payload);
        },

        updatePaymentSettingsRedsys(payload) {
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateRedsysPayment', payload);
        },

        createPaymentSettingsUnicre(payload) {
            return $http.post(appConfig.apiUrl + 'paymentConfig/createUnicrePayment', payload);
        },

        updatePaymentSettingsUnicre(payload) {
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateUnicrePayment', payload);
        },



        createPaymentSettingsDummy(form, assignmentChanges) {
		   const payload = {
               paymentConfig: {
                   alias: form.alias,
                   bankAccountType: form.bankAccountType,
                   bankName: form.bankName,
                   bankCutoffInMinutes: form.bankCutoffInMinutes,
                   bankCutoffTimeZone: form.bankCutoffTimeZone
               },
               departments: assignmentChanges
           };
           return $http.post(appConfig.apiUrl + 'paymentConfig/createDummy', payload);
        },

        updatePaymentSettingsDummy(id, form, assignmentChanges) {
            const payload = {
                paymentConfig: {
                    id,
                    alias: form.alias,
                    bankAccountType: form.bankAccountType,
                    bankName: form.bankName,
                    bankCutoffInMinutes: form.bankCutoffInMinutes,
                    bankCutoffTimeZone: form.bankCutoffTimeZone
                },
                departments: assignmentChanges
            };
            return $http.post(appConfig.apiUrl + 'paymentConfig/updateDummy', payload);
        },

        markAsFallback(id) {
            const payload = {id};
            return $http.post(appConfig.apiUrl + 'paymentConfig/assignAsFallback', payload);
        },

        getDepartments(paymentSetting, collection) {
            const items = [];

            if (collection && collection.length) {
                for (let i = collection.length - 1; i > -1; i--) {
                    const department = collection[i];
                    if (department.paymentConfig && department.paymentConfig.id === paymentSetting.id)
                        items.push(department);
                    
                    if (paymentSetting.fallback && !department.paymentConfig)
                    		items.push(department);
                }
            }

            return items;
        },

        hasExistingDefault(rootScope) {
            return !!((rootScope.merchantInfo && rootScope.merchantInfo.paymentConfig));
        },

        isPaymentSettingsUpdateAllowed() {
            if (merchantService.behaviour(merchantService.merchantInfo, 'schoolLike')) {
                return appConfig.isMCAdmin || appConfig.isPartner;
            } else {
                return appConfig.isElevatedUser;
            }
        },

        delete(id) {
            return $http.post(appConfig.apiUrl + 'paymentConfig/delete', {id});
        },

    getAliasOfPaymentConfig(paymentConfigList, paymentConfigRef) {
        let alias = '';
        if (paymentConfigRef) {
            const id = paymentConfigRef.id;
            angular.forEach(paymentConfigList, (paymentConfig) => {
                if (id === paymentConfig.id) {
                    alias = paymentConfig.alias;
                }
            });
        } else {
            alias = 'Undefined';
            angular.forEach(paymentConfigList, (paymentConfig) => {
                if (paymentConfig.fallback) {
                    alias = paymentConfig.alias + ' (Default)';
                }
            });
        }
        return alias;
    }
}));



// WEBPACK FOOTER //
// ./src/payment-gateway/services/paymentgateway.services.js